import React from "react";
import { Omit } from "typings";
import { SxStyleProp } from "theme-ui";
import { Text as TextBase, TextProps } from "rebass";
import { theme } from "../../theme";

export interface Props extends Omit<TextProps, "fontWeight" | "css"> {
  sx?: SxStyleProp;
  fontWeight?: keyof typeof theme.fontWeights;
  transform?: "uppercase" | "lowercase" | "capitalize";
  truncate?: boolean;
  strike?: boolean;
  underline?: boolean;
  marked?: boolean;
  password?: boolean;
}

const Text: React.FunctionComponent<Props> = React.forwardRef(
  (
    {
      as = "span" as "span",
      sx,
      transform,
      truncate,
      strike,
      underline,
      marked,
      fontWeight,
      password,
      ...restProps
    },
    ref,
  ) => (
    <TextBase
      ref={ref}
      as={as}
      sx={{
        fontSize: 1,
        fontWeight,

        ...(transform && {
          textTransform: transform,
        }),

        ...(strike && {
          textDecoration: "line-through",
        }),

        ...(underline && {
          textDecoration: "underline",
        }),

        ...(marked && {
          backgroundColor: "yellow",
          color: "black",
        }),

        ...(truncate && {
          display: "block",
          width: "100%",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }),

        ...(password && {
          WebkitTextSecurity: "disc",
          MozTextSecurity: "disc",
          TextSecurity: "disc",
          fontSize: "2rem",
        }),

        ...(sx as any),
      }}
      {...restProps}
    />
  ),
);

Text.displayName = "Text";

export default Text;
